var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "border-work d-flex flex-wrap justify-content-center" },
    [
      _c("div", { staticClass: "left" }, [
        _c("img", {
          staticClass: "img",
          attrs: { src: "/static/img/acCleaning/svg/decision-making.svg" }
        }),
        _vm._v(" "),
        _c("div", [
          _c("h4", { attrs: { "data-aos": "fade-left" } }, [
            _vm._v(_vm._s(_vm.$t("ac_cleaning.help_center_section.title")))
          ]),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "sub-text", attrs: { "data-aos": "fade-right" } },
            [_vm._v(_vm._s(_vm.$t("ac_cleaning.help_center_section.subtitle")))]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "button" }, [
          _c(
            "a",
            {
              staticClass: "d-flex justify-content-center align-items-center",
              attrs: { href: "javascript:void(0)" },
              on: { click: _vm.handlePhoneClick }
            },
            [
              _c("img", {
                staticClass: "img-call",
                attrs: { src: "/static/img/acCleaning/svg/call.svg" }
              })
            ]
          ),
          _vm._v(" "),
          _vm.showPhoneOptions
            ? _c("div", { staticClass: "mobile-phone-modal" }, [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column align-items-center" },
                  [
                    _c("p", [_vm._v("กรุณาเลือกเบอร์โทร:")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: "tel:+6621131138" },
                        on: {
                          click: function($event) {
                            _vm.showPhoneOptions = false
                          }
                        }
                      },
                      [_vm._v("02-113-1138")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: "tel:+66927572999" },
                        on: {
                          click: function($event) {
                            _vm.showPhoneOptions = false
                          }
                        }
                      },
                      [_vm._v("092-757-2999")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "px-2 rounded-md border-0",
                        staticStyle: { width: "80%" },
                        on: {
                          click: function($event) {
                            _vm.showPhoneOptions = false
                          }
                        }
                      },
                      [_vm._v("ปิด")]
                    )
                  ]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "button" }, [
          _c(
            "a",
            {
              staticClass: "d-flex justify-content-center align-items-center",
              attrs: { href: _vm.socialContacts.lineUrl, target: "_blank" }
            },
            [
              _c("img", {
                staticClass: "img-line",
                attrs: { src: "/static/img/acCleaning/svg/line.svg" }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "button" }, [
          _c(
            "a",
            {
              staticClass: "d-flex justify-content-center align-items-center",
              attrs: { href: _vm.socialContacts.fbMessageUrl, target: "_blank" }
            },
            [
              _c("img", {
                staticClass: "img-messenger",
                attrs: { src: "/static/img/acCleaning/svg/messenger.svg" }
              })
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e5258d2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e5258d2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acCleaningRe/HelpCenter.vue
// module id = 1608
// module chunks = 0